import parse from "html-react-parser";
import { ReactNode, useEffect, useState } from "react";
import BlurryBackground from "../components/BlurryBackground";
import Footer from "../components/Footer";
import Logo from "../components/Logo";
import { useAuthContext } from "../providers/AuthProvider";

type LoginLayoutProps = {
    children: ReactNode;
    title: string;
    subtitle?: string;
    helperText?: string | ReactNode;
    display?: string;
}

const StatusMessage = () => {
    const { apiCall } = useAuthContext();
    
    const [message, setMessage] = useState(null)

    useEffect(() => {
        const checkStatus = async () => {
            try {
                const response = await apiCall({ action: 'check_status' });
                if (response?.data?.status !== 200 && response?.data?.data) {
                    setMessage(response.data.data);
                }
            } catch (error: any) {
                console.error('Error checking status:', error);
            }
        }
        checkStatus();
    }, [])

    if(!message) return <></>
    return (
        <div className="alert alert-danger" dangerouslySetInnerHTML={{ __html: message }} />
    )
}

const LoginLayout = ({ children, title, subtitle = '', helperText = '', display = 'col-lg-10' }: LoginLayoutProps) => (
    <div className="section d-flex justify-content-center align-items-center h-100">

        <div className="bg-circles position-fixed overflow-hidden w-100 h-100">
            <BlurryBackground />
            <div className="position-absolute bankid-login-bg bg-white rounded-pill d-flex flex-column" style={{ zIndex: 1 }}></div>
        </div>

        <div className="position-absolute h-100">
            <div className="container h-100 d-flex flex-column">
                <div className="row justify-content-center align-items-center flex-grow-1">
                    <div className={`${display} text-center mt-5`}>
                        <Logo contain="center" />

                        <div className="row mt-4 mt-lg-5">
                            <h1 className="text-center">{title}</h1>
                            <p className="text-center" dangerouslySetInnerHTML={{ __html: subtitle ?? '' }} />
                        </div>
                        <StatusMessage />
                        

                        <div className="row mt-3 mx-1">
                            {children}
                            <span className="d-block text-center">
                                {typeof helperText === "string" ? parse(helperText) : helperText || ''}
                            </span>
                        </div>
                    </div>
                </div>

                <div className="row mt-auto">
                    <Footer login />
                </div>
            </div>
        </div>
    </div >
);

export default LoginLayout;